import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest,
} from "@/helper/requests"
// import {executeRequest} from "@/store/modules/utils";

const state = {
  mails: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: null,
    error: null,
  }
}

const getters = {
  getMails: state => state.mails.items,
  getMailsCount: state => state.mails.count,
  getMailsCurrentUrl: state => state.mails.currentUrl,
  getMailsDetail: state => state.mails.detail,
  isLoadingMails: state => state.mails.loading,
  saveMailsError: state => state.mails.error,
}

const actions = {
  loadMails: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.MAILS.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingMails) {
      commit('SET_MAILS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_MAILS', data.results)
          commit('SET_MAILS_COUNT', data.count)
          commit('SET_MAILS_CURRENT_URL', url)
          commit('SET_MAILS_NEXT_URL', data.next)
          commit('SET_MAILS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_MAILS_LOADING_END')
          commit('SAVE_MAILS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  loadMailsDetail: ({ commit, dispatch, getters }, { id, finalizer = () => {}, catcher = () => {} }) => {
    if (!getters.getMailsCurrentUrl) {
      dispatch('loadMails', {
        finalizer: () => {
          const data = getters.getMails.find(el => el.id === id)
          if (data) {
            commit('SET_MAILS_DETAIL', data)
          }
          finalizer()
        },
        catcher
      })
    } else {
      const data = getters.getMails.find(el => el.id === id)
      if (data) {
        commit('SET_MAILS_DETAIL', data)
      }
      finalizer()
    }
  },
}

const mutations = {
  SET_MAILS: (state, value) => {
    state.mails.items = value
  },
  SET_MAILS_DETAIL: (state, value) => {
    state.mails.detail = value
  },
  SET_MAILS_COUNT: (state, value) => {
    state.mails.count = value
  },
  SET_MAILS_CURRENT_URL: (state, value) => {
    state.mails.currentUrl = value
  },
  SET_MAILS_NEXT_URL: (state, value) => {
    state.mails.next = value
  },
  SET_MAILS_PREV_URL: (state, value) => {
    state.mails.prev = value
  },
  SET_MAILS_LOADING: (state) => {
    state.mails.loading = true
  },
  SET_MAILS_LOADING_END: (state) => {
    state.mails.loading = false
  },
  SAVE_MAILS_ERROR: (state, error) => {
    state.mails.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
